module.exports = __webpack_public_path__ + "static/media/saf-logo.834a37ec.svg";